export const getDeviceType = () =>
  window.Cordova ? window.device.platform : "Web";
export const isIOS = () => (window.Cordova && window.device.platform === "iOS");
